import { createUseStyles } from 'react-jss'
import RevealGrid from '@/components/RevealGrid'
import { getFileExtension } from '@/utils/strings'
import style from './style'

const useStyles = createUseStyles(style)

const DownloadTable = ({
  title,
  items,
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <RevealGrid
        cols={1}
        className={classes.title}
      >
        <h3>{title}</h3>
      </RevealGrid>
      <RevealGrid
        cols={1}
        className={classes.table}
      >
        {items.map((item, i) => (
          <li
            className={classes.item}
            key={i.toString()}
          >
            <a
              href={item.file_attach}
              download
              target="_blank"
            >
              <span className={classes.label}>{item.file_title}</span>
              <span className={classes.value}>
                <svg><use xlinkHref="#ico-arrow-left" /></svg>
                {getFileExtension(item.file_attach)}
              </span>
            </a>
          </li>
        ))}
      </RevealGrid>
    </div>
  )
}

export default DownloadTable
